import { Statistic } from 'src/types/statistics/Statistics';

const DB_NAME = 'statisticsDB';
const STORE_NAME = 'metrics';
const DB_VERSION = 1;

let db: IDBDatabase | null = null;

const openDatabase = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    if (db) {
      resolve(db);
      return;
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const database = request.result;
      if (!database.objectStoreNames.contains(STORE_NAME)) {
        database.createObjectStore(STORE_NAME, { autoIncrement: true });
      }
    };

    request.onsuccess = () => {
      db = request.result;
      resolve(db);
    };

    request.onerror = () => {
      reject(request.error);
    };
  });
};

export const saveMetricToDB = async (
  metricName: string,
  statistic: Statistic,
) => {
  const database = await openDatabase();
  return new Promise<void>((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, 'readwrite');
    const store = transaction.objectStore(STORE_NAME);

    const request = store.add({ metricName, statistic });

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};

export const deleteOldestMetric = async (): Promise<{
  metricName: string;
  statistic: Statistic;
} | null> => {
  const database = await openDatabase();

  return new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, 'readwrite');
    const store = transaction.objectStore(STORE_NAME);

    const request = store.openCursor();

    request.onsuccess = () => {
      const cursor = request.result as IDBCursorWithValue | null;

      if (cursor) {
        const oldestEntry = cursor.value;

        const deleteRequest = cursor.delete();

        deleteRequest.onsuccess = () => {
          resolve(oldestEntry);
        };

        deleteRequest.onerror = () => {
          reject(deleteRequest.error);
        };
      } else {
        resolve(null);
      }
    };

    request.onerror = () => {
      reject(request.error);
    };
  });
};
